import React from "react";

function Top5ProducerExporterField({top5Arr, by}){
	let passedValues = [];
	if(by === "producer"){
		passedValues = top5Arr.top5ProducerArr;
	} else if(by === "exporter"){
		passedValues = top5Arr.top5ExporterArr;
	} 
	return(
		passedValues.map( (passedValue) =>(
			<tr>
				<td>{passedValue["country"]}</td>  
				<td>{passedValue["quantity_tonnes_"]}</td>
			</tr>
		))
	)
}

export default Top5ProducerExporterField;